import { type ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { AuthContext, type AuthUser } from "@/src/auth/hooks/use-auth";
import { fetchMe, logoutClient } from "@/src/auth/services/auth-http.service";
import { getAccessToken } from "@/src/common/services/http.service";

export function AuthProvider({ children }: { children: ReactNode }) {
	const [user, setUser] = useState<AuthUser | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const refresh = useCallback(async () => {
		if (!getAccessToken()) {
			setUser(null);
			setIsLoading(false);
			return;
		}
		setIsLoading(true);
		try {
			const me = await fetchMe();
			setUser(me ? { id: me.id, email: me.email, is_super_admin: me.is_super_admin } : null);
		} finally {
			setIsLoading(false);
		}
	}, []);

	const logout = useCallback(() => {
		logoutClient();
		setUser(null);
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	const value = useMemo(() => ({ user, isLoading, refresh, logout }), [user, isLoading, refresh, logout]);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
